import { useMMKVObject } from 'react-native-mmkv';
import { getNativeStorage } from 'src/lib/storage';
export default function usePersistedState(storageKey, defaultValue) {
    const [state, setState] = useMMKVObject(storageKey.key, getNativeStorage(storageKey.scope));
    return [state ?? defaultValue, setState];
}
